import React from "react"
import { Nav } from "react-bootstrap"
import { Link } from "gatsby"
import SocialShareModal from "@components/socialShareModal/modal"

export default ({ toggle }) => (
  <div className="navigation">
    <Nav className="flex-column">
      {/* <PostModal html="About">
        <img src={Post1Background} className="img-fluid mb-3" alt="" />

        <h3>
          FLUO is a conscious lifestyle brand born precisely when it is needed
          most.
        </h3>
        <p className="lead">FLUO is hope. FLUO is light. FLUO is love.</p>
        <p>
          Not only does FLUO champion a philosophy of a way of life known to be
          a very powerful state of human experience, but we are devoted to a new
          era of humanity––an evolution heralding a revolution of our
          Consciousness.
        </p>
        <p>However you arrived here, it wasn't by mistake.</p>
        <p>
          This is your invitation to join a family of co-creators who will bring
          a tidal wave of improvement to our collective well-being. A family
          dedicated to helping us all reclaim our human dignities and
          connection. We're not perfect, but we're not alone. Along with FLUO,
          we shall rise up together to live our lives to the fullest, to Feel
          Alive!
        </p>
      </PostModal> */}
      <Link to="/">Home</Link>
      <Link to="/rally/">We’re here to rally</Link>
      <Link to="/belief/">our beliefs</Link>
      <Link to="/why-fluo/">why fluo foundation?</Link>
      <Link to="/stewardship/">consciousness & Stewardship</Link>
      <Link to="/shop/">Shop</Link>
      <Link to="/inside-fluo/">Advocacy</Link>

      <SocialShareModal
        linkToShare="https://fluo-peh.netlify.app/"
        mclass="social-share-modal"
      />
    </Nav>
  </div>
)
